<template>
    <div class="n2-center-container" style="background-color: #fff;">
        <div id="home-page">
            <app-content v-bind:name="'web.home.main'"></app-content>
            <div class="n3-main-form" style="position: relative;">
                <div class="n3-row-container">
                    <div class="n3-row" style="padding-top: 3px;">
                        <div class="n3-half" style="position: relative;">
                            <div>
                                <app-autocomplete v-on:selected="selectOrigin($event)" v-model="query.origin_id"
                                    v-bind:title="$t('pages.home.travel_from')" v-bind:item_css_class="'notranslate'"
                                    v-bind:placeholder="$t('pages.home.stop_place_holder')" v-bind:items="stops"
                                    v-bind:text_field="'name'" v-bind:separator="' '" v-bind:value_field="'id'"
                                    v-bind:errors="model_errors.origin_id">
                                </app-autocomplete>
                            </div>
                            <app-loader v-bind:active="loadingDepartures"></app-loader>
                        </div>
                        <div class="n3-half" style="position: relative;">
                            <div class="destination-stop-container">
                                <app-autocomplete ref="el_stop_to" v-on:selected="selectDestination()"
                                    v-model="query.destination_id" v-bind:title="$t('pages.home.travel_to')"
                                    v-bind:item_css_class="'notranslate'"
                                    v-bind:placeholder="$t('pages.home.stop_place_holder')" v-bind:items="destinations"
                                    v-bind:text_field="'name'" v-bind:separator="' '" v-bind:value_field="'id'"
                                    v-bind:errors="model_errors.destination_id">
                                </app-autocomplete>
                            </div>
                            <app-loader v-bind:active="loadingArrivals"></app-loader>
                        </div>
                        <div class="icon-swap" v-on:click="swap">
                            <span class="material-symbols-outlined">
                                swap_vert
                            </span>
                        </div>
                    </div>
                </div>
                <div class="n3-row-container" v-if="query.origin_id && query.destination_id">
                    <div class="n3-row">
                        <div class="n3-half">
                            <app-calendar v-model="query.outward_date" v-on:selected="selectOutwardDate($event)"
                                v-bind:title="$t('pages.home.outward_date')" v-bind:time_zone="time_zone"
                                v-bind:locale="locale" v-bind:value_field="'id'"
                                v-bind:errors="model_errors.outward_date" v-bind:min_date="iso_today"
                                v-bind:sunday_css="'holiday'" v-bind:dates_css="dates_css"
                                v-bind:valid_dates="calendar_dates"
                                >
                            </app-calendar>
                        </div>
                        <div class="n3-half">
                            <app-calendar v-model="query.backward_date" v-bind:clear_button="true"
                                v-on:selected="selectBackwardDate($event)" v-bind:title="$t('pages.home.backward_date')"
                                v-bind:time_zone="time_zone" v-bind:locale="locale" v-bind:value_field="'id'"
                                v-bind:errors="model_errors.backward_date" v-bind:min_date="backward_min_date"
                                v-bind:sunday_css="'holiday'" v-bind:dates_css="dates_css"
                                v-bind:valid_dates="calendar_dates"
                                >
                            </app-calendar>
                        </div>
                    </div>
                </div>
                <div class="n3-row-container" v-if="query.origin_id && query.destination_id && query.outward_date">
                    <div class="n2-product-group" v-for="group in product_groups" v-bind:key="group">
                        <div class="product-group-content">
                            <div class="product-group-title">{{ group.name }}</div>
                            <div class="products-section">
                                <div class="product-container" v-for="product in group.products" v-bind:key="product">
                                    <div class="product">
                                        <div class="quanitity-selector">
                                            <div class="quanity-btn" v-on:click="changeQuantity(product, -1)">
                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                            </div>
                                            <input class="product-quantity-field" type="text"
                                                autocomplete="one-time-code" v-model="product.quantity"
                                                v-on:change="changeQuantity(product, $event.target.value, 'set')" />
                                            <div class="quanity-btn" v-on:click="changeQuantity(product, 1)">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                        <div class="product-name">
                                            <span>{{ product.name }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="zeroProducts && product_groups.length == 0" style="color: #b94a48; padding: 6px;">
                        {{ $t('pages.home.error_products_not_found') }}
                    </div>
                </div>
                <div class="n3-row-container" style="padding: 6px;">
                    <ul class="n2-errors n2-margin-top">
                        <li v-if="validate('origin')">
                            {{ $t('pages.home.error_origin') }}
                        </li>
                        <li v-if="validate('destination')">
                            {{ $t('pages.home.error_destination') }}
                        </li>
                        <li v-if="validate('outward_date')">
                            {{ $t('pages.home.error_outward_date') }}
                        </li>
                        <li v-if="validate('backward_date')">
                            {{ $t('pages.home.error_backward_date') }}
                        </li>
                        <li v-if="validate('travel_money')">
                            {{ $t('pages.home.error_travel_money') }}
                        </li>
                        <li v-if="validate('birthdate')">
                            {{ $t('pages.home.error_birthdate') }}
                        </li>
                        <li v-if="validate('kolumbus_card')">
                            {{ $t('pages.home.error_kolumbus_card') }}
                        </li>
                        <li v-if="validate('products')">
                            {{ $t('pages.home.error_products') }}
                        </li>
                    </ul>
                </div>
                <div class="n2-text-right" style="padding: 0 6px 6px;">
                    <button class="n2-button-1" v-on:click="searchTrips">{{ $t('pages.home.search_trips') }}</button>
                </div>
                <app-loader v-bind:active="loadingFares"></app-loader>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AppAutocomplete from '../components/shared/autocomplete.vue';
import AppCalendar from '../components/shared/calendar.vue';
import AppLoader from '../components/shared/loader.vue';
import AppContent from '../components/shared/content.vue';
import localizationHelper from '../helpers/localization-helper';

import { StopService, ProductService, TripService, TicsentService } from '../services'

export default {
    name: 'PageIndex',
    components: {
        AppAutocomplete,
        AppCalendar,
        AppLoader,
        AppContent
    },
    data: function () {
        return {
            time_zone: 'Europe/Oslo',
            model_errors: {},
            query: {
                origin_id: '',
                destination_id: '',
                outward_date: '',
                backward_date: '',
                backward_calendar_month: '',
                roundtrip: null,
                locale: ''
            },
            valid_dates: [],
            invalid_fields: [],
            loadingDepartures: false,
            loadingArrivals: false,
            loadingFares: false,
            zeroProducts: false,
            dates_css: [
                { date: '2024-01-01', css: 'holiday' },
                { date: '2024-03-28', css: 'holiday' },
                { date: '2024-03-29', css: 'holiday' },
                { date: '2024-03-31', css: 'holiday' },
                { date: '2024-04-01', css: 'holiday' },
                { date: '2024-05-01', css: 'holiday' },
                { date: '2024-05-09', css: 'holiday' },
                { date: '2024-05-17', css: 'holiday' },
                { date: '2024-05-19', css: 'holiday' },
                { date: '2024-05-20', css: 'holiday' },
                { date: '2024-12-25', css: 'holiday' },
                { date: '2024-12-26', css: 'holiday' },
                { date: '2025-01-01', css: 'holiday' },
                { date: '2025-04-17', css: 'holiday' },
                { date: '2025-04-18', css: 'holiday' },
                { date: '2025-04-20', css: 'holiday' },
                { date: '2025-04-21', css: 'holiday' },
                { date: '2025-05-01', css: 'holiday' },
                { date: '2025-05-17', css: 'holiday' },
                { date: '2025-05-29', css: 'holiday' },
                { date: '2025-06-08', css: 'holiday' },
                { date: '2025-06-09', css: 'holiday' },
                { date: '2025-12-25', css: 'holiday' },
                { date: '2025-12-26', css: 'holiday' },
                { date: '2026-01-01', css: 'holiday' },
                { date: '2026-04-02', css: 'holiday' },
                { date: '2026-04-03', css: 'holiday' },
                { date: '2026-04-05', css: 'holiday' },
                { date: '2026-04-06', css: 'holiday' },
                { date: '2026-05-01', css: 'holiday' },
                { date: '2026-05-14', css: 'holiday' },
                { date: '2026-05-17', css: 'holiday' },
                { date: '2026-05-24', css: 'holiday' },
                { date: '2026-05-25', css: 'holiday' },
                { date: '2026-12-25', css: 'holiday' },
                { date: '2026-12-26', css: 'holiday' },
            ]
        }
    },
    computed: {
        ...mapGetters('globalization', [
            'app_locale',
            'locale',
            'language'
        ]),
        ...mapGetters('planner', [
            'calendar_dates',
            'stops',
            'destinations',
            'product_list',
            'search_paras',
            'selected_products'
        ]),
        iso_today: {
            get() {
                let today = localizationHelper.convertTimeZone(new Date(), this.time_zone);
                return today;
            }
        },
        backward_min_date() {
            let d = new Date(this.query.outward_date);
            let today = new Date(this.iso_today);
            return d > today ? this.query.outward_date : this.iso_today;
        },
        product_groups() {
            let selectedProducts = [];
            try {
                selectedProducts = JSON.parse(this.selected_products);
            } catch (error) {
                selectedProducts = [];
            }
            try {
                var groups = this.product_list.reduce((acc, p) => {
                    var obj = Object.assign({}, p)
                    let key = obj.category.name
                    obj.quantity = 0;

                    var foundProduct = selectedProducts.find(e => e.id == obj.id);
                    if (foundProduct) {
                        obj.quantity = foundProduct.quantity;
                    }

                    var found = acc.find(element => {
                        return element.name === key
                    })
                    if (!found) {
                        acc.push({ name: key, products: [obj] })
                    }
                    else {
                        found.products.push(obj)
                    }
                    return acc
                }, []);

            }
            catch {
                return [];
            }
            return groups;
        }
    },
    watch: {
        'locale': async function () {
            if (this.query.origin_id && this.query.destination_id && this.query.outward_date) {
                await this.loadFares();
            }
        }
    },
    created: function () {
        this.stopService = new StopService();
        this.productService = new ProductService();
        this.tripService = new TripService();
        this.ticsentService = new TicsentService();
    },
    mounted: async function () {
        await this.load();
    },
    beforeRouteUpdate(to, from, next) {
        next();
    },
    methods: {
        load: async function () {
            Object.assign(this.query, this.search_paras);
            if (!this.query.outward_date) {
                this.query.outward_date = this.iso_today;
            }
            else if (new Date(this.query.outward_date) < new Date(this.iso_today)) {
                this.query.outward_date = this.iso_today;
            }
            if (this.stops.length == 0) {
                try {
                    this.loadingDepartures = true;
                    var stopResult = await this.stopService.search({ page_size: 500 });
                    this.$store.commit('planner/set_stops', stopResult.data);
                }
                finally { this.loadingDepartures = false; }
            }
            if (this.destinations.length == 0 || this.search_paras.origin_id != this.query.origin_id) {
                await this.loadDestinations();
            }
            if (!this.product_groups
                || this.product_groups.length == 0
                || this.search_paras.origin_id != this.query.origin_id
                || this.search_paras.destination_id != this.query.destination_id
                || this.search_paras.outward_date != this.query.outward_date
                || this.search_paras.locale != this.locale
            ) {
                await this.loadFares();
            }
            if (this.search_paras.origin_id != this.query.origin_id
                || this.search_paras.destination_id != this.query.destination_id
                || !this.calendar_dates || this.calendar_dates.length == 0
            ) {
                await this.loadCalendar();
            }
        },
        loadCalendar: async function () {
            try {
                this.loadingFares = true;
                if (this.query.origin_id && this.query.destination_id) {
                    let calendarDates = await this.ticsentService.getCalendar({
                        SaleChannelId: '4',
                        FromStopId: this.query.origin_id,
                        FromGroup: '',
                        ToStopId: this.query.destination_id,
                        ToGroup: ''
                    });
                    this.valid_dates = calendarDates;
                    this.$store.commit('planner/set_calendar_dates', calendarDates);
                }
            }
            finally {
                this.loadingFares = false;
            }
        },
        loadDestinations: async function () {
            if (this.query.origin_id) {
                try {
                    this.loadingArrivals = true;
                    let stopResult = await this.stopService.search({ page_size: 200, origin: 'stop_id:' + this.query.origin_id });
                    this.$store.commit('planner/set_destinations', stopResult.data);
                }
                finally { this.loadingArrivals = false; }
            }
        },
        loadFares: async function () {
            if (this.query.origin_id && this.query.destination_id && this.query.outward_date) {
                this.zeroProducts = false;
                try {
                    this.loadingFares = true;
                    var productResult = await this.productService.search({ origin: this.query.origin_id, destination: this.query.destination_id, date: this.query.outward_date, locale: this.locale });
                    this.$store.commit('planner/set_product_list', productResult.data);
                    if (productResult.data.length == 0) {
                        this.zeroProducts = true;
                    }
                }
                catch {
                    this.zeroProducts = true;
                }
                finally {
                    this.loadingFares = false;

                }
            }
        },
        selectOrigin: async function () {
            await this.loadDestinations();
            await this.loadFares();
            //if (this.query.origin_id && !this.query.destination_id) {
            //this.$nextTick(() => this.$refs.el_stop_to.$el.children[0].focus())
            //}
            await this.loadCalendar();
            this.$store.commit('planner/set_search_paras', this.query);
        },
        selectDestination: async function () {

            this.$store.commit('planner/set_search_paras', this.query);
            if (this.query.origin_id && this.query.destination_id) {
                await this.loadCalendar();
            }
            await this.loadFares();
        },
        swap: async function () {
            let from = this.query.origin_id;
            this.query.origin_id = this.query.destination_id;
            this.query.destination_id = from;

            this.$store.commit('planner/set_search_paras', this.query);

            await this.loadDestinations();


        },
        selectOutwardDate: async function (e) {
            this.query.outward_date = e;
            this.$store.commit('planner/set_search_paras', this.query);
            if (this.query.backward_date && new Date(this.query.outward_date) > new Date(this.query.backward_date)) {
                this.query.backward_date = this.query.outward_date;
            }
            await this.loadFares();
        },
        selectBackwardDate: async function (e) {
            this.query.backward_date = e;
            this.$store.commit('planner/set_search_paras', this.query);
        },
        changeQuantity: function (product, amount, mode) {
            let ps = [];
            try {
                ps = JSON.parse(this.selected_products);
            } catch (error) {
                ps = [];
            }
            let found = false;
            if (ps.length > 0) {
                let foundProduct = ps.find(element => element.id == product.id);
                if (foundProduct) {
                    found = true;
                    if (mode == 'set') {
                        foundProduct.quantity = parseInt(amount);
                    }
                    else {
                        foundProduct.quantity += parseInt(amount);
                    }
                }
            }
            if (!found) {
                ps.push({ id: product.id, quantity: amount });
            }
            let selected = JSON.stringify(ps.filter(a => a.quantity > 0));
            this.$store.commit('planner/set_selected_products', selected);

        },
        validate: function (name) {
            return this.invalid_fields.includes(name);
        },
        searchTrips: async function () {
            let tripRequest = {
                origin_id: this.query.origin_id,
                destination_id: this.query.destination_id,
                outward_date: this.query.outward_date,
                backward_date: this.query.backward_date,
                roundtrip: this.query.backward_date ? true : false,
                products: '',
            };
            let products = [].concat(...this.product_groups.map(a => a.products)).filter(a => a.quantity > 0)
                .map(p => {
                    return { id: p.id, quantity: p.quantity, product_type:p.product_type, data: p.data }
                });
            tripRequest.products = JSON.stringify(products);
            this.invalid_fields = [];
            if (!tripRequest.origin_id) {
                this.invalid_fields.push('origin');
            }
            if (!tripRequest.destination_id) {
                this.invalid_fields.push('destination');
            }
            if (!tripRequest.outward_date) {
                this.invalid_fields.push('outward_date');
            }
            if (products.length == 0) {
                this.invalid_fields.push('products');
            }
            if (this.invalid_fields.length == 0) {
                this.$store.commit('current_session/set_trip_search_query', tripRequest);
                this.$router.push({ path: `/${this.app_locale}/trips`, query: tripRequest })
            }
        }
    }
}
</script>
<style lang="scss" scoped></style>
